export const STRAVA_ATHLETE_COOKIE_NAME = 'strava_athlete';
export const STRAVA_ACCESS_TOKEN_COOKIE_NAME = 'strava_access_token';
export const STRAVA_REFRESH_TOKEN_COOKIE_NAME = 'strava_refresh_token';
